import React from 'react'
import CustomInput from '../shared/Input/CustomInput'
import { SelectForm } from '../shared/Input/SelectForm'
import { Patterns } from '../../models/common'
import { get } from 'http'

interface ProjectMemberProps {
    register: any
    visible?: boolean
    index: number
    errors?: any
    control?: any
    eduPrograms: { label: string, value: any }[]
}

function ProjectMember({ 
    register, 
    index, 
    visible = false, 
    errors, 
    control, 
    eduPrograms
}: ProjectMemberProps) {
    const genderOptions = [
        { label: 'Masculino', value: 'Masculino' },
        { label: 'Femenino', value: 'Femenino' },
        { label: 'Prefiero no decirlo', value: 'Prefiero no decirlo' }
    ];


    return visible ? (
        <div className='ProjectMemberContainer'>
            <label hidden={!visible}>Informacion del Integrante {index + 1}</label>
            <div className='ProjectMember'>
                <CustomInput capitalize='uppercase' label="Nombre Completo" field={'projectMembers.' + index + '.name'} register={register} rules={{ required: true, maxLength: 150 }} visible={visible} errors={errors} />
                <CustomInput capitalize='none' label="Correo Electrónico" field={'projectMembers.' + index + '.email'} type='email' register={register} rules={{ required: true, maxLength: 150, pattern:Patterns.email }} visible={visible} errors={errors} />
                <SelectForm label="Género" field={'projectMembers.' + index + '.gender'} control={control} rules={{ required: true }} errors={errors} options={genderOptions} visible={visible} />
                <SelectForm label="Programa Educativo" field={'projectMembers.' + index + '.eduProgram'} control={control} rules={{ required: true }} errors={errors} options={eduPrograms} visible={visible} />
            </div>
        </div>
    ) : null
}

export default ProjectMember